<template>
  <v-list v-bind="$attrs" v-on="$listeners">
    <slot />
  </v-list>
</template>

<script>
export default {
  name: "BaseList",
};
</script>
